module.exports = (function() {
    //As the server is on UTC, the time is displaying as UTC.
    //Specifying that the time is in UTC prompts the browser to display in the local timezone
    return function(source){

        if(!source)
            return source;

        var isString = typeof source === "string";

        if(isString)
        {
            var timestamp = source.split(/[-T:. ]/);
            source = new Date(timestamp[0], timestamp[1]-1, timestamp[2], timestamp[3], timestamp[4], timestamp[5]);
        }

        if(typeof window === "undefined"){
            return new Date(source.toLocaleString() + ' UTC');
        }

        return source;
    };

})();


// WEBPACK FOOTER //
// ./src/common/LocalTimeConverter/LocalTimeConverter.js